import classNames from 'classnames';
import React from 'react';
import { useTranslation } from '../../contexts/translation-context';
import { FileUpload as TPAFileUpload } from '../../ui/autocomplete/wut/FileUpload';
import { classes } from '../../ui/file-upload/file-upload-wut.st.css';
export const FileInputWUT = ({ onFocus, onBlur, disabled, buttonText, valueSliderLimit, required, inputId, ariaLabelledBy, ariaDescribedBy, files, hover, handleChange, accept, fileInputRef, fileUploadButtonRef, textBelowButtonRef, fieldId })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classes.container
    }, /*#__PURE__*/ React.createElement(TPAFileUpload, {
        inputId: inputId,
        fileInputRef: fileInputRef,
        fileUploadButtonRef: fileUploadButtonRef,
        textBelowButtonRef: textBelowButtonRef,
        buttonText: buttonText,
        accept: accept,
        className: classNames(classes.root, classes.crop, {
            [classes.hover]: hover
        }),
        multiple: valueSliderLimit > 1,
        files: files,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        ariaRoleDescription: t('file-upload.aria-roledescription'),
        ariaLabelledBy: ariaLabelledBy,
        ariaDescribedBy: ariaDescribedBy,
        required: required,
        fieldId: fieldId
    }));
};

//# sourceMappingURL=file-input-wut.js.map